
// 封装 iview 的 this.$Message.info

// this.$alert.info(res)

import { Message } from 'view-design';

const messageInfo = { }

messageInfo.info = function (res) {
    if(res.data){
      
        Message.info({
          content:  res.data.message,
          duration:3
        });
    }else{
        
        Message.info({
          content:  res,
          duration:3
        });
    }
    
}

export default messageInfo;